import { forwardRef } from 'react'
import { FileAnalysis } from '../../../types'

interface DataPreviewTableProps {
    analysis: FileAnalysis
}

// Accessible preview table extracted from modal
const DataPreviewTable = forwardRef<HTMLDivElement, DataPreviewTableProps>(({ analysis }, ref) => {
    if (!analysis?.previewData || !analysis.columns) return null
    return (
        <div ref={ref} data-testid="data-preview-table-wrapper" className="bg-white rounded-lg border border-gray-200 overflow-hidden flex-1">
            <div className="custom-scrollbar" style={{ 
                height: '100%', 
                minHeight: '350px', 
                maxHeight: '55vh',
                overflow: 'auto'
            }}>
                <table className="w-full text-xs" style={{minWidth: 'max-content', width: 'auto'}}>
                    <caption className="sr-only">Preview of first 10 rows</caption>
                    <thead className="bg-brand-700 sticky top-0">
                        <tr>
                            {analysis.columns.map((column) => (
                                <th scope="col" key={column.name} className="px-4 py-2 text-left font-medium text-white border-b border-brand-700" style={{minWidth: '200px', width: '200px', whiteSpace: 'nowrap'}}>
                                    <span>{column.name}</span>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-100">
                        {analysis.previewData.slice(0, 10).map((row, rowIdx) => (
                            <tr key={rowIdx} className="hover:bg-gray-50">
                                {analysis.columns.map((column, colIdx) => (
                                    <td key={column.name} tabIndex={rowIdx === 0 && colIdx === 0 ? -1 : undefined} className="px-4 py-2 text-gray-900 border-b border-gray-100 focus:outline-none focus:ring-2 focus:ring-brand-500" style={{minWidth: '200px', width: '200px', whiteSpace: 'nowrap'}}>
                                        <div className="truncate" style={{maxWidth: '180px'}} title={row[column.name]?.toString()}>
                                            {row[column.name]?.toString() || '-'}
                                        </div>
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
})

DataPreviewTable.displayName = 'DataPreviewTable'
export default DataPreviewTable
